import React, { useState } from 'react';
//import { residentsMock } from './mockData';
//import constants from '../constant';
import { useEffect } from 'react';
import { API_BASE_URL, ResidentGetAPIEndpoint, ResidentDeleteAPIEndpoint } from '../constant';
import Header from './Header';
import Pagination from './Pagination';
import "./css/paginationtable.css";
import "./css/residents.css";
import Select from "react-select";

import { SoldStatusMock, OwnerTenantMock } from './mockData';


function Residents() {
  const token = sessionStorage.getItem("JWTtoken");
  const url = window.location.hostname;
  console.log("Current URL: " + url);
  const [form, setForm] = useState({ name: "", email: "", phone: "", apartment: "", owner: "", sold: 0 });
  const [editingId, setEditingId] = useState(null);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 4; 

const indexOfLast = currentPage * recordsPerPage;
const indexOfFirst = indexOfLast - recordsPerPage;

const currentRecords = users.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(users.length / recordsPerPage);


const userType = sessionStorage.getItem("userType"); // or session
const isUserTypeAdmin = userType === "admin" ? true : false;


  const fetchUsers = async () => {
      try {
        const apiURL = API_BASE_URL + ResidentGetAPIEndpoint;
        const response = await fetch(apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });
        const data = await response.json();

        if (data.status) {
          setUsers(data.data);
        } else {
          setError(data.message || "Failed to fetch users");
        }
      } catch (err) {
        setError("Server error");
      } finally {
        setLoading(false);
      }
    };



useEffect(() => {
    const fetchUsers = async () => {
      try {
        const apiURL = API_BASE_URL + ResidentGetAPIEndpoint;





        //const response = await fetch(apiURL); working

        //start section to send autorization token in header
        const token = sessionStorage.getItem("JWTtoken");
        const response = await fetch(apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });

        //end section to send autorization token in header


        const data = await response.json();

        if (data.status) {
          setUsers(data.data);
        } else {
          setError(data.message || "Failed to fetch users");
        }
      } catch (err) {
        setError("Server error");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  if (loading) return <p>Loading users...</p>;
  if (error) return <p>{error}</p>;
    
    





  const validateEmail = (email) => {
    // Simple email regex
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  
  const validatePhone = (phone) => {
    // Must be exactly 10 digits
    return /^\d{10}$/.test(phone);
  };

  
    // Apartment uniqueness using filter
    // const existingApartments = residents.filter(
    //     r => r.apartment === form.apartment && r.id !== editingId
    // ).length;


       const validate = () => {
  // Validation: Name, phone, and apartment must not be empty
    if (!form.name.trim() || !form.phone.trim() || !form.apartment.trim()) {
      alert("Name, Mobile Number, and Apartment number are required!");
      return; // Stop submission
    }

     // Email validation (optional, only if not empty)
    if (form.email.trim() && !validateEmail(form.email.trim())) {
      alert("Please enter a valid email address!");
      return;
    }

    // Mobile number validation
    if (!validatePhone(form.phone.trim())) {
      alert("Mobile number must be exactly 10 digits!");
      return;
    }
    // Apartment uniqueness validation
    // if (existingApartments > 0) {
    //   alert("Apartment number must be unique!");
    //   return;
    // }  

  return true;
};




  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

     
    
    


    /*if (editingId) {
      setResidents(residents.map(r => r.id === editingId ? { ...form, id: editingId } : r));
      setEditingId(null);
    } else {
      setResidents([...residents, { ...form, id: Date.now() }]);
    }*/
   if (editingId) {
      setUsers(users.map(r => r.id === editingId ? { ...form, id: editingId } : r));
      setEditingId(null);
       try {
        const updateApiURL = API_BASE_URL + "/resident/update_resident.php";
        const payload = {
          ...form,                 // existing form fields
          id: editingId
        };


    const response = await fetch(updateApiURL,
      {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
         },
        body: JSON.stringify(payload)
      }
    );

    const result = await response.json();

    if (result.status) {
      alert("Resident updated successfully");

      // 🔥 reload table with updated data
      fetchUsers();

      //setEditForm(null);
    } else {
      alert(result.message);
    }
  } catch (err) {
    alert("Server error");
  }


    } else {
      try {
      //setUsers([...users, { ...form, id: Date.now() }]);
      const addApiURL = API_BASE_URL + "/resident/add_resident.php";
      const response = await fetch(addApiURL,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(form)
      }
    );

    const result = await response.json();


    if (result.status) {
      alert("Resident added successfully");
      setForm({
        name: "",
        email: "",
        phone: "",
        apartment: "",
        owner: "",
        sold: 0
      });
      fetchUsers();
      
  //     setResidents(prev =>
  //   prev.map(item =>
  //     item.id === form.id ? { ...item, ...for } : item
  //   )
  // );


  // setUsers(prev =>
  //   prev.map(item =>
  //     item.id === form.id ? { ...item, ...form } : item
  //   )
  // );
  
    } else {
      alert(result.message);
      
    }
  } catch (error) {
    alert("Server error".error);
  }
};

    setForm({ name: "", email: "", phone: "", apartment: "", owner: "", sold: 0 });
  };

  const handleEdit = (r) => {
    //setSelectedValue(r.owner); 
    //alert(JSON.stringify(r) + "\n" + selectedValue);
    
    setForm({ name: r.name, email: r.email, phone: r.phone, apartment: r.apartment, owner: String(r.owner), sold: String(r.sold) });
    
    //setSelectedValue(OwnerTenantMock.map(data => data.value === r.owner ? { ...form, owner: r.owner } : ""));
    //const initialOption = OwnerTenantMock.map(opt => opt.value === r.owner);
    //alert(r.owner);
     
    //alert(selectedValue);
    setEditingId(r.id);
  };


  // const handleChangeOwner = (event) => {
  //   setSelectedValue(event.target.value);    
  // }

  const handleDelete = async (residentId) => {
    //setUsers(users.filter(r => r.id !== id));
try {
        const deleteApiURL = API_BASE_URL + ResidentDeleteAPIEndpoint;
        const payload = { id : residentId}; 
        const response = await  fetch(deleteApiURL,
          {
            method: "Delete",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify(payload)
          }
        );
        const result = await response.json();
        

        if (result.status) {
          alert("Resident deleted successfully");
          await fetchUsers(); // Refresh the residents list
        } else {
          alert(result.message);
        }
      }
      catch (error) {
        alert("Server error".error);
      }

  }
  
  


  return (<>
    <Header/>
    <div>
      <h1>Residents</h1>
      {
        isUserTypeAdmin && <div> 

          <input placeholder="Name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}/>
          <input placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}/>
          <input placeholder="Phone" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })}/>
          <input placeholder="Flat Number" value={form.apartment} onChange={e => setForm({ ...form, apartment: e.target.value })}/>
          { 1 == 2 && <input placeholder="Ownership" value={form.owner} onChange={e => setForm({ ...form, ownership: e.target.value })}/>}
          <select   value={form.owner} onChange={e => setForm({ ...form, owner: e.target.value })}>
            <option value="">Select Ownership</option>
              {OwnerTenantMock.map(r => <option key={r.id} value={String(r.id)}>{r.name}</option>)}
          </select>


          { 1 == 2 && <input placeholder="SoldStatus" value={form.sold} onChange={e => setForm({ ...form, soldStatus: e.target.value })}/>}


          <select value={form.sold} onChange={e => setForm({ ...form, sold: e.target.value })}>
            <option value="">Select Sold Status</option>
              {SoldStatusMock.map(r => <option key={r.id} value={String(r.id)}>{r.name}</option>)}
          </select>

          <button onClick={handleSubmit}>{editingId ? "Update" : "Add"} Resident</button>
          
        </div>
      }
      <div className="table-container">
      <table style={{ border:"1px solid", width: "100%" }}>
        <thead>
          <tr style={{ backgroundColor: "burlywood" }}>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Apartment</th>
            <th>Owner</th>
            <th>Sold</th>
            {isUserTypeAdmin && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {
            
            currentRecords.length > 0 ? (
            currentRecords.map((r, index) => {
              const soldStatus = r.sold === 1 ? "Sold" : "Available";

              return (
              <tr  key={r.id} className={index % 2 === 0 ? "even" : "odd" } >
                <td>{r.name}</td>
                <td>{r.email}</td>
                <td>{r.phone}</td>
                <td>{r.apartment}</td>
                <td>{r.owner}</td>
                <td>{soldStatus}</td>
                {isUserTypeAdmin && <td><button onClick={() => handleEdit(r)}>Edit</button> <button onClick={() => handleDelete(r.id)}>Delete</button></td>}
              </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="5" align="center">No records found</td>
            </tr>
          )
        }
      
        </tbody>
      </table>
      </div>
    <div style={{ marginTop: "10px" }}>
    <button
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}> Prev 
  </button>

  {[...Array(totalPages)].map((_, i) => (
    <button
      key={i}
      onClick={() => setCurrentPage(i + 1)}
      style={{
        fontWeight: currentPage === i + 1 ? "bold" : "normal",
        margin: "0 5px"
      }}
    >
      {i + 1}
    </button>
  ))}

  <button
    onClick={() =>
      setCurrentPage(prev => Math.min(prev + 1, totalPages))
    }
    disabled={currentPage === totalPages}
  >
    Next
  </button> { indexOfFirst + 1} to {users.length < indexOfLast ? users.length : indexOfLast} of Total Record {users.length} 
</div>
    </div>

    {/*<Pagination recordCount={users.length} currentWorkingPage={currentPage} setCurrentWorkingPage={currentPage}  />*/}




    </>
  );
}

export default Residents;
